module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('data-form', {
    attrs: {
      "entity": _vm.server,
      "model": "servers",
      "fields": _vm.fields,
      "cancel": false
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1ee19635!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/server/ServerSettings.vue
// module id = 1129
// module chunks = 2